import React from 'react';
import { useClinicalDemo } from '../../contexts/ClinicalDemoContext';
import type { Visit } from '../../types/clinicalDemo';
import { formatDate, formatTimestamp } from '../../utils/demoStorage';
import { glassPanel } from '../../utils/demoUi';
import { visitStatus, visitStatusLabels } from '../../utils/clinicalDemo';
import { CategoryTag, categoryStyles } from './CategoryTag';
import { EntryForm } from './EntryForm';
export function VisitColumn({
  visit,
  canEdit
}: {
  visit: Visit;
  canEdit: boolean;
}) {
  const {
    state
  } = useClinicalDemo();
  const entries = state.entries.filter(entry => entry.visitId === visit.id);
  const status = visitStatus(state, visit.id);
  return <section aria-labelledby={`${visit.id}-title`} className={`${glassPanel} flex flex-col p-5 lg:p-6`} data-id="element-198" data-mp="949n577sx7ni">
      <div className="flex flex-wrap items-start justify-between gap-2" data-id="element-199" data-mp="2ytbog3vgryi9">
        <div data-id="element-200" data-mp="2yrihsokupea9">
          <p className="text-xs text-ink-muted" data-id="element-201" data-mp="2tui9s84fy1gi">
            {visit.id} · {formatDate(visit.date)}
          </p>
          <h2 id={`${visit.id}-title`} className="mt-0.5 font-heading text-lg font-bold text-ink-dark" data-id="element-202" data-mp="11s05ovm3bifv">
            {visit.label}
          </h2>
        </div>
        <span className="rounded-full border border-line bg-white px-2.5 py-0.5 text-xs font-semibold text-navy" data-id="element-203" data-mp="15sivkk4faeff">{visitStatusLabels[status]}</span>
      </div>
      <p className="mt-2 text-sm text-ink-muted" data-id="element-204" data-mp="wruhxqixyg32">{visit.context}</p>

      <ol className="mt-4 space-y-3" data-id="element-205" data-mp="i3rcci8t96es">
        {entries.map(entry => <li key={entry.id} className={`rounded-lg border-l-4 bg-white px-4 py-3 ${categoryStyles[entry.category].border}`} data-id="element-206" data-mp="i1mwr31juiyo">
            <div className="flex flex-wrap items-center gap-2" data-id="element-207" data-mp="93bafd7pu7c1">
              <CategoryTag category={entry.category} data-id="element-208" data-mp="94w4l1q4bo9d" />
              {entry.isAddendum && <span className="rounded-md border border-navy/20 bg-surface-muted px-2 py-0.5 text-xs font-semibold text-navy" data-id="element-209" data-mp="e2e4y3q2kv5r">
                  Addendum{entry.addendumTo ? ` to ${entry.addendumTo}` : ''}
                </span>}
            </div>
            <p className="mt-2 leading-relaxed text-ink-dark" data-id="element-210" data-mp="3h4zf0l894aw6">{entry.text}</p>
            <p className="mt-1 text-xs text-ink-muted" data-id="element-211" data-mp="3ceaq9dnyhs0q">
              {entry.id} · {entry.authorRole} · {formatTimestamp(entry.at)}
            </p>
          </li>)}
      </ol>

      {canEdit && <EntryForm visitId={visit.id} data-id="element-212" data-mp="32fuuuyhwbwlf" />}
    </section>;
}